import App from './App.svelte';
import AppComponent from './AppComponent.svelte';
import { inject_whole_app } from './Utils/ConfigUtils.svelte';

const parent_element_id = 'tutorialcategories';
let app;
if (inject_whole_app()) {
	app = new App({
		target: document.getElementById(parent_element_id) || document.body
	});
} else {
	app = new AppComponent({
		target: document.getElementById(parent_element_id) || document.body
	});
}

export default app;